import ErrorIcon from '@mui/icons-material/Error';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function PageErrorFallback({ error, resetErrorBoundary }) {
  const  { t } = useTranslation();
  // resetErrorBoundary() this will reset page state... not needed because we render a fallback component.

  return (
    <div role="alert" style={styles.outerContainer}>
      <div style={styles.innerContainer}>
        <ErrorIcon style={styles.errorIcon}/>
        <h1>
          {t('SOMETHING_WENT_WRONG')}
        </h1>
        <div className='padding-top-8'>{t('AN_UNEXPECTED_ERROR_OCCURED_AND_HAS_BEEN_SENT_TO_BRIDGEGATE_DEV_SUPPORT')}</div>
        <div className='padding-bottom-12'>{t('PLEASE_REFRESH_THE_PAGE_AND_TRY_AGAIN')}</div>
        {/* <Button 
          style={{backgroundColor: "#243d7d"}} 
          variant="contained" 
          startIcon={<RefreshIcon />}
          onClick={resetErrorBoundary}
        >
          {t('REFRESH')}
        </Button> */}
      </div>
    </div>
  );
}

const styles = {
  outerContainer: {
    width: "100%",
    height: "80%", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center"
  },
  innerContainer: {
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center"
  },
  errorIcon: {
    color: "#c50000",
    fontSize: "128px"
  }
}